export const CLIENT_API_KEY = process.env.NEXT_PUBLIC_CLIENT_API_KEY || '';
export const APP_VERSION = process.env.NEXT_PUBLIC_APP_VERSION;
export const variants = [25, 50, 100, 250];
export const ITEMS_PER_PAGE = 10;
export const LET_THEM_CHOOSE = 'Let Them Choose';
export const CHOOSE_YOUR_OWN = 'Choose Your Own';
export const CHOOSE_FROM_MILLIONS_OF_RESTAURANTS =
    'CHOOSE FROM MILLIONS OF RESTAURANTS, SPAS & SALONS';
export const THEIR_CHOICE = 'Their';
export const YOUR_CHOICE = 'Your';
export const StripePaymentMethodType = {
    amazon_pay: 'Amazon Pay',
    google_pay: 'Google Pay',
};
export const RESTAURANT_OF_THEIR_CHOICE = 'Restaurant of Their Choice';
export const SPA_OR_SALON_OF_THEIR_CHOICE = 'Spa or Salon of Their Choice';
export const TO_USE_AT_RESTAURANT_OF_THEIR_CHOICE =
    'To use at Restaurant of Their Choice';
export const TO_USE_AT_SPA_OR_SALON_OF_THEIR_CHOICE =
    'To use at Spa or Salon of Their Choice';
export const A_RESTAURANT_OF_THEIR_CHOICE = 'a Restaurant of Their Choice';
export const A_SPA_OR_SALON_OF_THEIR_CHOICE = 'a Spa or Salon of Their Choice';
export const CURRENCY = 'usd';
export const VARIANT_CARD_CONFIG =
    process.env.NEXT_PUBLIC_VARIANT_CARD_CONFIG || '$50';
export enum CategorySearch {
    RESTAURANT = 'restaurant',
    SPA = 'spa',
    SERVICE_PROVIDER = 'serviceprovider',
}
export enum SearchService {
    GOOGLE = 'google',
    YELP = 'yelp',
}
